import { ButtonBase } from './ButtonBase';
import { ButtonState } from './ButtonState';
import { AbstractMouseEvent } from './AbstractMouseEvent';
import { MouseDownEvent } from './MouseDownEvent';
import { MouseUpEvent } from './MouseUpEvent';
import { SceneObjectType } from './SceneObjectType';

export class CheckBox extends ButtonBase {
  get runtimeType(): SceneObjectType {
    return SceneObjectType.Checkbox;
  }

  private _checked: boolean = false;

  get upState(): ButtonState {
    return this._checked ? ButtonState.Down : ButtonState.Normal;
  }

  get downState(): ButtonState {
    return this._checked ? ButtonState.Down : ButtonState.Normal;
  }

  get state(): ButtonState {
    return super.state;
  }

  set state(value: ButtonState) {
    this.checked = value === ButtonState.Down;
  }

  get checked(): boolean {
    return this._checked;
  }

  set checked(value: boolean) {
    this._checked = value;
    super.state = this._checked ? ButtonState.Down : ButtonState.Normal;
  }

  onTouch(mouseEvent: AbstractMouseEvent): void {
    super.onTouch(mouseEvent);
    if (mouseEvent instanceof MouseDownEvent) {
      mouseEvent.accept();
    }
    if (mouseEvent instanceof MouseUpEvent) {
      if (this.isInPoint(mouseEvent.upEvent.location)) {
        this.checked = !this.checked;
        this.dispatchClick();
      }
      mouseEvent.accept();
    }
  }
}
